import React from 'react';
import { useLanguage } from '../contexts/LanguageContext';

function LanguageToggle({ theme }) {
  const { language, toggleLanguage } = useLanguage();

  // SVG flags for cross-browser compatibility (especially Windows Chrome/Edge)
  const USFlag = () => (
    <svg width="20" height="15" viewBox="0 0 60 40" xmlns="http://www.w3.org/2000/svg">
      <rect width="60" height="40" fill="#B22234"/>
      <path d="M0,0 h60 v3.08 h-60z M0,6.15 h60 v3.08 h-60z M0,12.31 h60 v3.08 h-60z M0,18.46 h60 v3.08 h-60z M0,24.62 h60 v3.08 h-60z M0,30.77 h60 v3.08 h-60z M0,36.92 h60 v3.08 h-60z" fill="#fff"/>
      <rect width="24" height="21.54" fill="#3C3B6E"/>
      <g fill="#fff">
        {[...Array(50)].map((_, i) => {
          const row = Math.floor(i / 6);
          const col = i % 6;
          const offsetRow = row % 2 === 1;
          return (
            <circle
              key={i}
              cx={3 + col * 4 + (offsetRow ? 2 : 0)}
              cy={2 + row * 2.4}
              r="0.8"
            />
          );
        })}
      </g>
    </svg>
  );

  const MXFlag = () => (
    <svg width="20" height="15" viewBox="0 0 60 40" xmlns="http://www.w3.org/2000/svg">
      <rect width="20" height="40" fill="#006847"/>
      <rect x="20" width="20" height="40" fill="#fff"/>
      <rect x="40" width="20" height="40" fill="#CE1126"/>
      <g transform="translate(30, 20)">
        <circle cx="0" cy="0" r="4" fill="#C69B6D" stroke="#A0783A" strokeWidth="0.5"/>
        <path d="M-1.5,-2 L1.5,-2 L1.5,0 L-1.5,0z" fill="#8B4513"/>
        <ellipse cx="0" cy="-3" rx="2" ry="1.5" fill="#228B22"/>
      </g>
    </svg>
  );

  return (
    <div style={{
      display: 'flex',
      alignItems: 'center',
      gap: '0.5rem'
    }}>
      <span style={{
        fontSize: '0.9rem',
        color: theme?.colors?.textSecondary || '#666',
        fontWeight: '500'
      }}>
        {/* {t('language')}: */}
      </span>
      <button
        onClick={toggleLanguage}
        style={{
          display: 'flex',
          alignItems: 'center',
          gap: '0.5rem',
          padding: '0.5rem 0.75rem',
          backgroundColor: theme?.colors?.surface || '#fff',
          border: `2px solid ${theme?.colors?.primary || '#1976d2'}`,
          borderRadius: theme?.borderRadius || '6px',
          color: theme?.colors?.primary || '#1976d2',
          fontSize: '0.9rem',
          fontWeight: '600',
          cursor: 'pointer',
          transition: 'all 0.2s ease',
          minWidth: '48px',
          height: '40px',
          justifyContent: 'center'
        }}
        onMouseOver={(e) => {
          e.currentTarget.style.backgroundColor = theme?.colors?.primary || '#1976d2';
          e.currentTarget.style.color = theme?.colors?.surface || '#fff';
        }}
        onMouseOut={(e) => {
          e.currentTarget.style.backgroundColor = theme?.colors?.surface || '#fff';
          e.currentTarget.style.color = theme?.colors?.primary || '#1976d2';
        }}
      >
        <span style={{
          display: 'flex',
          alignItems: 'center'
        }}>
          {language === 'en' ? <USFlag /> : <MXFlag />}
        </span>
        <span>
          {language === 'en' ? 'EN' : 'ES'}
        </span>
      </button>
    </div>
  );
}

export default LanguageToggle;